// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__10xcw","left":"StickyBox_left__2JJfP","right":"StickyBox_right__3EXG6"};